import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Alert, Box, CircularProgress,
} from '@mui/material';
import { fetchPublicV2App } from '../../api/studioV2.api';
import StudioV2AppRuntimeShell from '../../components/studio/StudioV2AppRuntimeShell';

export default function StudioV2PublishPage() {
  const { id } = useParams();
  const [app, setApp] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!id) {
        setError('App id required');
        return;
      }
      const { app: doc, error: err } = await fetchPublicV2App(id);
      if (cancelled) return;
      if (err) {
        setError(err);
        return;
      }
      setApp(doc);
    })();
    return () => { cancelled = true; };
  }, [id]);

  if (error) {
    return (
      <Box sx={{
        p: 4, minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <Alert severity="error" sx={{ maxWidth: 560 }}>{error}</Alert>
      </Box>
    );
  }

  if (!app) {
    return (
      <Box sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 320,
      }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <StudioV2AppRuntimeShell definition={app.definition || {}} mongoId={app._id} pluginPanels={app.pluginPanels || []} />
  );
}
